import { useTranslation } from 'react-i18next'
import { HintText, SuggestionLink } from './styled-components'

type Props = {
  suggestion: string | null
  onAccept: (email: string) => void
}

const EmailSuggestion = ({ suggestion, onAccept }: Props) => {
  const { t } = useTranslation()

  if (!suggestion) return null

  return (
    <HintText>
      {t('subscriptionForm:customer_module.email.domainSuggestion')}{' '}
      <SuggestionLink
        role='button'
        tabIndex={0}
        onClick={() => onAccept(suggestion)}
        onKeyDown={e => e.key === 'Enter' && onAccept(suggestion)}
      >
        {suggestion}
      </SuggestionLink>
      {' ?'}
    </HintText>
  )
}

export default EmailSuggestion
